import { render, staticRenderFns } from "./index.vue?vue&type=template&id=15bba16d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=15bba16d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bba16d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15bba16d')) {
      api.createRecord('15bba16d', component.options)
    } else {
      api.reload('15bba16d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=15bba16d&scoped=true", function () {
      api.rerender('15bba16d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/stock/distribution/ratio/index.vue"
export default component.exports